// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundingPatchDto
 */
export interface IFundingPatchDto {
    /**
     * 
     * @type {number}
     * @memberof IFundingPatchDto
     */
    amount: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IFundingPatchDto
     */
    amounts_grouped_by_instrument_ids?: { [key: string]: number; };
}

/**
 * Check if a given object implements the IFundingPatchDto interface.
 */
export function instanceOfIFundingPatchDto(value: object): value is IFundingPatchDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function IFundingPatchDtoFromJSON(json: any): IFundingPatchDto {
    return IFundingPatchDtoFromJSONTyped(json, false);
}

export function IFundingPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundingPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'amounts_grouped_by_instrument_ids': json['amounts_grouped_by_instrument_ids'] == null ? undefined : json['amounts_grouped_by_instrument_ids'],
    };
}

export function IFundingPatchDtoToJSON(json: any): IFundingPatchDto {
    return IFundingPatchDtoToJSONTyped(json, false);
}

export function IFundingPatchDtoToJSONTyped(value?: IFundingPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'amounts_grouped_by_instrument_ids': value['amounts_grouped_by_instrument_ids'],
    };
}

